import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {usePageStateSelector} from '../../../hooks/state'
import {SecondaryButton} from '../../styled-components/secondary-button'
import {SectionButtonProps} from './interfaces'

export const SectionButton: React.FC<SectionButtonProps> = ({
  onClick,
  dataHook,
  className,
  narrowerButton,
  children,
}) => {
  const mobile = usePageStateSelector(isMobile)

  return (
    <SecondaryButton
      className={className}
      mobile={mobile}
      onClick={onClick}
      dataHook={dataHook}
      narrowerButton={narrowerButton}
    >
      {children}
    </SecondaryButton>
  )
}
